'use strict';

var Feedback = L.Class.extend({
    includes: L.Mixin.Events,
    data: {},
    record: function(data) {
        L.extend(this.data, data);
        this.fire('change');
    }
});

module.exports = new Feedback();



//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/src/feedback.js
// module id = 88
// module chunks = 0